import { Helmet } from 'react-helmet-async';

const Meta = ({
  title = 'Jacques André Éditeur, éditeur de livres depuis 1984',
  description = `Maison d'édition indépendante : poésie, art, biographies, sciences humaines et sociales.`,
  keywords = `livres, édition, poésie, art, biographies, sciences humaines et sociales`,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

export default Meta;
